import React from "react";
import NFePayment from "./Payments";
import NFeShippingTransporter from "./ShippingTransporter";
import OtherExpenses from "./OtherExpenses";

import { CreateNFeContext } from "../Context";

import Row from "../../../../../_components/Layout/Row";
import Column from "../../../../../_components/Layout/Column";

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  if (context.step !== "payments-transport") {
    return <span />;
  }
  return (
    <Row>
      <Column xs="12" md="8" lg="8" xl="8">
        <NFePayment />
      </Column>
      <Column xs="12" md="4" lg="4">
        <NFeShippingTransporter />
        <div className="py-4">
          <OtherExpenses />
        </div>
      </Column>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/index.jsx